<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Şube</label>
            <v-validator :errors="errors" parameter="BranchId" :watch="branch">
                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Organizasyonel Konum</label>
            <v-validator :errors="errors" parameter="CollarStatusId" :watch="value.CollarStatusId">
                <v-select-list v-model="collarStatus" label="Name" placeholder="Organizasyonel Konum" :options="collarStatuses"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-validator :errors="errors" parameter="ValidityStartDate" :watch="value.ValidityStartDate">
                <v-date-picker v-model="value.ValidityStartDate" placeholder="Başlangıç Tarihi"></v-date-picker>
            </v-validator>
        </div>
        <!-- <div class="col-12 mb-1">
            <label class="form-label">Bitiş Tarihi</label>
            <v-validator :errors="errors" parameter="ValidityEndDate" :watch="value.ValidityEndDate">
                <v-date-picker v-model="value.ValidityEndDate" :disabled-date="disabledDate" placeholder="Bitiş Tarihi"></v-date-picker>
            </v-validator>
        </div> -->
        <div class="col-12">
            <label class="form-label">Haftanın Günleri</label>
            <table class="table table-sm table-bordered w-100 mb-0">
                <tbody>
                    <tr v-for="(d,index) in value.DaysOfWeek" :key="d.day">
                        <th class="w-50">{{d.name}}</th>
                        <td class="w-50">
                            <v-date-picker v-model="value.DaysOfWeek[index].value" type="time" with-seconds placeholder="Çalışma Süresi"></v-date-picker>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data' 
import CompanyApi from '@/api/company'
import moment from 'moment'

export default {
    props:{
        value:Object,
        errors:Object
    },
    mounted(){
        this.getBranches()
        this.getCollarStatuses()
    },
    data(){
        return {
            branches:[],
            collarStatuses:[]
        }
    },
    methods:{
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{ 
                this.branches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res=>{
                this.collarStatuses = res.data.Data
            })
        },
        disabledDate(date){
            let startDate = moment(this.value.StartDate,'YYYY-MM-DD')
            let currentDate = moment(date)
            if(currentDate.isAfter(startDate) && currentDate.add(1,'days').date() == 1){
                return false
            }else return true
        },
    },
    computed:{
        collarStatus:{
            get:function(){
                return this.collarStatuses.find(m=>m.Id==this.value.CollarStatusId)
            },
            set:function(value){
                this.value.CollarStatusId = value?.Id || null
            }
        },
        branch:{
            get:function(){
                return this.branches.find(b=>b.Id==this.value.BranchId)
            },
            set:function(value){
                this.value.BranchId = value?.Id || null
            }
        },
    }
}
</script>

<style>

</style>